
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

/* ======================================== */
/* 5.  AUTOMATION STATUS                    */
/* ======================================== */
export const AutomationStatus = () => {
  const automations = [
    { name: "Welcome Flow", status: "Active" },
    { name: "Cart Abandonment", status: "Paused" },
    { name: "Win‑Back", status: "Draft" },
  ];
  const bg = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");
  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>
        Automation Status
      </Heading>
      <VStack align="stretch" spacing={2}>
        {automations.map((a) => (
          <HStack key={a.name} justify="space-between">
            <Text>{a.name}</Text>
            <Badge colorScheme={a.status === "Active" ? "green" : a.status === "Paused" ? "yellow" : "gray"}>
              {a.status}
            </Badge>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};